export default __webpack_public_path__ + "static/media/whisper-oval-carbon-road.805d963e.glb";